import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError from 'layers/errorHandling/apiError/component'
import {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  operations as siteOperations,
  selectors as siteSelectors,
  actions as siteActions,
} from 'store/siteManager'
import { Formik } from 'formik'

import HostAllStaffModalComponent from './component'

export const HostAllStaffModalContainer = ({
  clearError,
  flowLabel,
  hasApiError,
  handleClose,
  kickoffHosted,
  modals,
  siteId,
  updateSitePreferences,
}) => {
  useEffect(() => {
    if (kickoffHosted) {
      return
    }
    updateSitePreferences(siteId, {
      k5Digital: {
        kickoffHosted: true,
      },
      mspDigital: {
        kickoffHosted: true,
      },
    })
  }, [kickoffHosted])

  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  return (
    <Formik initialValues={{}}>
      {() => (
        <HostAllStaffModalComponent
          flowLabel={flowLabel}
          goBack={() => {}}
          handleClose={closeModal}
          handleNextButtonClick={closeModal}
          hasApiError={hasApiError}
          modals={modals}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors?.selectSiteById(state, ownProps.siteId)
  const { sitePreferences = {} } = site || {}
  const { k5Digital = {} } = sitePreferences
  const { kickoffHosted } = k5Digital
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults

  return {
    hasApiError: !!error,
    site,
    kickoffHosted,
  }
}

const mapDispatchToProps = {
  updateSitePreferences: siteOperations.updateSitePreferences,
  clearError: siteActions.clearError,
}

HostAllStaffModalContainer.propTypes = {
  clearError: PropTypes.func,
  dispatch: PropTypes.func,
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  hasApiError: PropTypes.bool,
  kickoffHosted: PropTypes.bool,
  modals: PropTypes.array,
  siteId: PropTypes.number,
  updateSitePreferences: PropTypes.func,
}

const mapper = entry => {
  const { modals, flowLabel } = entry || {}
  return {
    modals,
    flowLabel,
  }
}

const options = {
  entryId: '74VtZxc3iU7ZhEnRLAQ5ZV',
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    HostAllStaffModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
